import { Star } from 'lucide-react';

const StarRating = ({ rating, size = 14, interactive = false, onChange }) => {
  const stars = [1, 2, 3, 4, 5];

  return (
    <div className="inline-flex items-center gap-0.5">
      {stars.map((star) => {
        const Wrapper = interactive ? 'button' : 'span';
        return (
          <Wrapper
            key={star}
            {...(interactive
              ? {
                  type: 'button',
                  onClick: () => onChange?.(star),
                }
              : {})}
            className={interactive ? 'cursor-pointer transition-transform hover:scale-110' : 'cursor-default'}
          >
            <Star
              size={size}
              className={
                star <= Math.round(rating)
                  ? 'fill-amber-400 text-amber-400'
                  : 'fill-surface-200 text-surface-200 dark:fill-surface-700 dark:text-surface-700'
              }
            />
          </Wrapper>
        );
      })}
    </div>
  );
};

export default StarRating;
